// NOTE: hooks
import { toast } from "sonner"
import useVideos from "./useVideos"
// NOTE: components
import Loading from "../../components/ui/Loading"
import VideosList from "../../components/videos/VideosList"

const Videos = () => {
  const {
    isLoadingVideos,
    isErrorVideos,
    errorVideos,
    videos
  } = useVideos()

  if (isLoadingVideos) return <Loading />

  if (isErrorVideos) toast.error("Couldn't get your videos", { description: errorVideos?.message })

  return (
    <div className="py-2">
      <VideosList videos={videos} />
    </div>
  )
}

export default Videos